import {onFind} from "@elements/init-modules-in-scope";
import {on, removeAttribute, find, findIn, closest, off, trigger, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import * as terracePlannerTabManager from './tabManager';
import * as terracePlannerApplicationLoading from './applicationLoading';
import * as terracePlannerButtonBar from './buttonBar';
import * as terracePlannerLoadTerrace from './loadTerrace';
import * as terracePlannerChangeHistory from './changeHistory';
import {disableLoadingOverlay, enableLoadingOverlay} from "./applicationLoading";
import {initInScope, cleanUpInScope} from "@elements/init-modules-in-scope";
import * as terracePlannerSurfaceUI from "./surface/surfaceUI";
import * as terracePlannerSubsidiarySelection from "./subsidiarySelection";
import * as formValidation from "@elements/form-validation";
import {savePlanner} from "./buttonBar";
import {initTabContent} from "./tabManager";
import Modal from "bootstrap/js/dist/modal";
import {
    bindShapeAreaListeners,
    bindConstellationAreaListeners
} from "./outline/outlineUI";

const TerracePlanner = _config.TerracePlanner;
window.TerracePlanner = TerracePlanner;

export function init() {
    onFind('.js-planner', function (planner) {
        TerracePlanner.element = planner;
        TerracePlanner.createNewDependency = function (dimension, factor) {
            return {
                dimension: dimension,
                factor: factor || TerracePlanner.FACTOR_FULL
            };
        }

        terracePlannerApplicationLoading.init();
        terracePlannerTabManager.init({});
        terracePlannerButtonBar.init();
        terracePlannerLoadTerrace.init();
        terracePlannerChangeHistory.init();
        terracePlannerSubsidiarySelection.init();



        if (matchMedia('(min-width: 768px)').matches) {
            let lastTop;

            on('scroll', () => {
                let top = find('.js-nav-container').getBoundingClientRect().height + findIn('.js-planner__nav-container', TerracePlanner.element).getBoundingClientRect().height + 20;

                if (lastTop === top) {
                    return
                }

                findIn('.js-planner__sidebar', TerracePlanner.element).style.top = top + 'px';

                lastTop = top;
            }, window);
        }
    });

    onFind('.js-planner__form-form', function (planerForm) {
        let container = closest('.js-planner__form', planerForm);
        let result = findIn('.js-planner__form-result', container);
        on('change', (evt) => {
            if (evt.target.getAttribute('data-trigger-prevent-change')) {
                return;
            }
            enableLoadingOverlay();

            let pendingRequest = axios({
                method: 'POST',
                url: planerForm.getAttribute('data-action'),
                data: new FormData(planerForm)
            });

            pendingRequest.then((data) => {
                if (data.status === 200) {
                    result.innerHTML = data.data;

                    cleanUpInScope(result);
                    initInScope(result);

                    // if (TerracePlanner.tabConfig['surface'].active === true) {
                    //     terracePlannerSurfaceUI.init();
                    // }
                }

                disableLoadingOverlay();
            });

        }, planerForm);
    });

    onFind('.js-planner__save', function (form) {
        formValidation.getApi(form).then((formApi) => {
            let formInstance = formApi.getFormInstance(),
                saveButton = findIn('.js-planner__save-btn', form);

            on('click', () => {
                formInstance.validate().then((state) => {
                    if (state === 'Valid') {
                        let name = findIn('.js-planner__save-name', form) ? findIn('.js-planner__save-name', form).value : TerracePlanner.terraceName,
                            shared = findIn('.js-planner__save-shared', form) ? findIn('.js-planner__save-shared', form).checked : '';

                        savePlanner(name, shared);

                        let modalInstance = Modal.getOrCreateInstance(closest('.modal', saveButton));
                        modalInstance.hide();
                    }
                });

            }, saveButton);
        });
    });

    onFind('.js-planner__group', function (container) {
        initTabContent(container.getAttribute('data-type'));
    });

    bindConstellationAreaListeners();
    bindShapeAreaListeners();


    onFind('.js-planner__inquiry', function (form) {
        on('form-validation.submit', () =>  {
            let target = findIn('.js-planner__inquiry-result', form),
                loading = findIn('.js-planner__inquiry-loading', form);


            let pendingRequest = axios({method: 'POST', url: form.getAttribute('data-action'), data: new FormData(form)});

            removeAttribute('hidden', loading);

            pendingRequest.then((data) => {
                target.innerHTML = data.data;

                setAttribute('hidden', true, loading);

                if (dataLayer) {
                    dataLayer.push({
                        'event': 'new_enquiry',
                        'location_ua': 'Terrace designer',   // Dynamisch befüllen
                        'location_ga4': 'terrace_designer'   // Dynamisch befüllen
                    });
                }
            });
        }, form);
    });

    onFind('.js-planner__scroll-to', function (button) {
        on('click', () =>  {
            let target = find(button.getAttribute('data-target'));
            let top = target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - find('.js-nav-container').getBoundingClientRect().height - 20;

            try {
                window.scroll({
                    top: top,
                    behavior: 'smooth'
                });
            } catch (e) {
                window.scrollTo(0, top);
            }
        }, button);
    });
}

export default TerracePlanner;